import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { GEOTAB_LANGUAGES_MAPPING } from '@app-core/constants/constants';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { UtilityService } from '@app-shared/services/common/utility.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { GEOTAB_DATABASE, GeotabCredentials } from 'src/app/geotab/geotab-utils';

@Injectable({
  providedIn: 'root',
})
export class GeotabApiService {
  constructor(
    private httpClient: HttpClient,
    private accessService: AccessService,
    private dataService: DataService,
    private translate: TranslateService,
    private utilityService: UtilityService,
    @Optional() @Inject(GEOTAB_DATABASE) private geotabDatabase: string
  ) {}

  public getLoginData(): Observable<any> {
    const { userName = '', sessionId = '', database = '' } = this.getGeotabCredentials();
    return this.httpClient.post('https://my.geotab.com/apiv1', {
      method: 'Get',
      params: {
        typeName: 'User',
        search: {
          name: userName,
        },
        credentials: {
          database: database,
          userName: userName,
          sessionId: sessionId,
        },
      },
    });
  }

  public getGeotabServer(): string {
    return sessionStorage.getItem(`rideview:server:${this.geotabDatabase}`);
  }

  public getGeotabCredentials(): GeotabCredentials {
    return JSON.parse(sessionStorage.getItem(`rideview:credentials:${this.geotabDatabase}`));
  }

  public updateGeotabUserMetadata(): void {
    this.getLoginData().subscribe({
      next: (resp) => {
        if (resp && resp.result && resp.result.length > 0) {
          const userDate = resp.result[0];
          const timezone = userDate.timeZoneId;
          const language = GEOTAB_LANGUAGES_MAPPING[userDate.language] || 'en';
          const metricUnit = userDate.isMetric ? 'Kilometers' : 'Miles';
          // timeformat is remaining

          this.accessService.currentTimeZone = timezone;
          this.dataService.currentTimeZone = timezone;

          this.accessService.currentLanguage = language;
          this.dataService.currentLanguage = language;
          this.translate.use(language);

          this.accessService.currentMetricUnit = metricUnit;
          this.dataService.currentMetricUnit = metricUnit;

          this.utilityService.updateUserMetadata({
            timezone,
            language,
            metricUnit,
          });
        }
      },
    });
  }
}
